export const CLAIM_FORM_CHANGE_TRACKING = {
  status: {
    source: 'claim_form.status',
    id: 27001,
  },
  claimDate: {
    source: 'claim_form.claim_date',
    id: 27002,
  },
  occurredDate: {
    source: 'claim_form.occurred_date',
    id: 27003,
  },
  closedDate: {
    source: 'claim_form.closed_date',
    id: 27004,
  },
  commodity: {
    source: 'claim_form.commodity',
    id: 27005,
  },
  description: {
    source: 'claim_form.description',
    id: 27006,
  },
  referenceNumber: {
    source: 'claim_form.reference_number',
    id: 27007,
  },
  claimValue: {
    source: 'claim_form.claim_value',
    id: 27008,
  },
  carrierPaid: {
    source: 'claim_form.carrier_paid',
    id: 27009,
  },
  atgPaid: {
    source: 'claim_form.atg_paid',
    id: 27010,
  },
  insurancePaid: {
    source: 'claim_form.insurance_paid',
    id: 27011,
  },
  salvageValue: {
    source: 'claim_form.salvage_value',
    id: 27012,
  },
  amountDeclined: {
    source: 'claim_form.amount_declined',
    id: 27013,
  },
  commentAdd: {
    source: 'claim_form.comments.add',
    id: 27014,
  },
  commentDelete: {
    source: 'claim_form.comments.delete',
    id: 27015,
  },
} as const;
